import { Component, OnInit } from '@angular/core';
import { MessageService } from 'primeng/api';
import { DialogService, DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { forkJoin } from 'rxjs';
import { FacilityService } from 'src/app/admin/servicies/facility.service';
import { SelfSchedulingConfigService } from 'src/app/admin/servicies/self-scheduling-config-service';
import { AdminSettingsService } from 'src/app/admin/servicies/admin-settings.service';
import { BaseComponent } from 'src/app/shared/components/base.component';
import { DropdownModel } from 'src/app/shared/models/response/settings/drop-down-model';
import { SelfSchedulingConfigModel } from 'src/app/shared/models/response/settings/self-scheduling-config-model';
import { NotificationSubTemplateResponseModel } from 'src/app/shared/models/response/settings/self-scheduling-config-model/notification-subtemplate-response-model';
import { PreviewTemplateComponent } from '../preview-template/preview-template.component';

@Component({
  selector: 'app-preview-configuration',
  templateUrl: './preview-configuration.component.html',
  styleUrls: ['./preview-configuration.component.sass'],
  standalone: false
})
export class PreviewConfigurationComponent extends BaseComponent implements OnInit {
  config: SelfSchedulingConfigModel;
  branchOptions: DropdownModel[] = [];
  classificationOptions: DropdownModel[] = [];
  insuranceOptions: DropdownModel[] = [];
  subTemplateOptions: DropdownModel[] = [];
  subTemplateList: NotificationSubTemplateResponseModel[] = [];
  selectedTemplate: NotificationSubTemplateResponseModel = new NotificationSubTemplateResponseModel();

  branchLabel: string;
  classificationLabel: string;
  insuranceLabel: string;
  templateLabel: string;

  constructor(private dynamicDialogRef: DynamicDialogRef,
    dynamicDialogConfig: DynamicDialogConfig,
    private settingsService: AdminSettingsService,
    private facilityService: FacilityService,
    private configService: SelfSchedulingConfigService,
    messageService: MessageService,
    private dialogueService: DialogService
  ) {
    super(messageService);
    this.config = dynamicDialogConfig.data;
  }

  ngOnInit(): void {
    this.loadData(() => {
      if (this.config) {
        this.setValues(this.config);
      }
    });
  }

  setValues(config: SelfSchedulingConfigModel) {
    this.branchLabel = this.getCommaSeparatedNames(config?.jsonValue?.branchIds, this.branchOptions);
    this.classificationLabel = this.getCommaSeparatedNames(config?.jsonValue?.classificationIds, this.classificationOptions);
    this.insuranceLabel = config?.jsonValue?.insuranceIds;
    this.templateLabel = this.subTemplateOptions.find(x => x.value === config?.jsonValue?.templateId)?.name;
    this.selectedTemplate = this.selectedTemplate = this.subTemplateList.find(x => x.id == config.jsonValue.templateId);

  }

  getCommaSeparatedNames(ids: string, objects: DropdownModel[]): string {
    const idArray = ids.split(',').map(Number);
    const matchingNames = objects
      .filter(obj => idArray.includes(obj.value))
      .map(obj => obj.name);
    return matchingNames.join(', ');
  }

  loadData(callback?: () => void) {
    this.loading = true;
    const classificationType$ = this.settingsService.GetClassificationTypes();
    const branchList$ = this.settingsService.GetBranchList();
    const insuranceList$ = this.facilityService.getAllInsuranceInfoes();
    const subTemplateList$ = this.configService.GetAllSubTemplate();

    forkJoin([classificationType$, branchList$, insuranceList$, subTemplateList$]).subscribe(
      (results) => {
        const [classificationTypeResult, branchListResult, insuranceList, subTemplateList] = results;

        this.processResult<any>(classificationTypeResult, () => {
          this.classificationOptions = classificationTypeResult.responseModel.map(item => ({
            value: item.crmClassificationTypeId,
            name: item.crmClassificationDisplayName
          }));
        });

        this.processResult<any>(branchListResult, () => {
          this.branchOptions = branchListResult.responseModel.map(item => ({
            value: item.crmBranchId,
            name: item.crmBranchName
          }));
        });

        this.processResult<any>(insuranceList, () => {
          this.insuranceOptions = insuranceList.responseModel.map(item => ({
            value: item.crmInsuranceInfoId,
            name: item.crmPolicyHolderName
          }));
        });

        this.processResult<any>(subTemplateList, () => {
          this.subTemplateOptions = subTemplateList.responseModel.map(item => ({
            value: item.id,
            name: item.appNotificationEventName
          }));

          subTemplateList.responseModel.forEach(item => {
            this.subTemplateList.push(item);
          });
        });

        this.loading = false;

        if (callback) {
          callback();
        }
      },
      (error) => {
        console.error('Error loading data', error);
        this.loading = false;
      }
    );
  }

  EmailPreviewClick() {
    this.dialogueService
      .open(PreviewTemplateComponent, {
        showHeader: true,
        closable: true,
        data: { roleId: 0, type: 'AppointmentInvitation', templateType: 'Email', subTemplate: this.selectedTemplate }
      })
  }

  SMSPreviewClick() {
    this.dialogueService
      .open(PreviewTemplateComponent, {
        showHeader: true,
        closable: true,
        data: { roleId: 0, type: 'AppointmentInvitation', templateType: 'SMS', subTemplate: this.selectedTemplate }
      });
  }
  
  close(result: any) {
    setTimeout(() => {
      this.dynamicDialogRef.close(result);
    }, 1);
  }
}
